import { defineStore } from 'pinia'
import api from '../services/api'
import type { UserRole } from '../pages/users/types'

interface UserState {
  userId: string
  userName: string
  email: string
  role: UserRole | null
  memberSince: string
  pfp: string
  is2FAEnabled: boolean
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userId: '',
      userName: 'anonymous',
      email: 'anonymous@email.com',
      role: null,
      memberSince: '',
      pfp: 'https://picsum.photos/id/22/200/300',
      is2FAEnabled: false,
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    async fetchUserProfile() {
      try {
        const res = await api.get('/auth/me')
        const user = res.data

        this.userId = user.id
        this.userName = user.email
        this.email = user.email
        this.role = user.role || null
        this.memberSince = new Date(user.created_at).toLocaleDateString()
      } catch (error: any) {
        console.error('Failed to fetch user profile:', error)
        throw error
      }
    },

    logout() {
      localStorage.removeItem('access_token')
      sessionStorage.removeItem('access_token')
      this.$reset()
    },
  },
})
